// TODO: type this — Vuex module context
/* eslint-disable @typescript-eslint/no-explicit-any */
type Ctx = any;
/* eslint-enable @typescript-eslint/no-explicit-any */

interface DropperState {
    draggedItem: unknown | null;
}

const DropperStore = {
    namespaced: true,
    state: {
        draggedItem: null as unknown | null,
    },
    mutations: {
        setDragged(state: DropperState, item: unknown): void {
            state.draggedItem = item;
        },
    },
    actions: {
        startDrag(context: Ctx, item: unknown): void {
            context.commit('setDragged', item);
        },
        reset({ commit }: Ctx): void {
            commit('setDragged', null);
        },
    },
    getters: {
        draggedItem: (state: DropperState) => {
            return state.draggedItem;
        },
        ready: (state: DropperState) => {
            return state.draggedItem != null;
        },
    },
};

export default DropperStore;
